module.exports = __webpack_public_path__ + "img/shky.b157fe0f.png";